<nb-card class="bottom-modal">
  <nb-icon class="close" icon="close" (click)="dismiss()"></nb-icon>
  <nb-card-body>
    <button *ngFor="let page of pages" class="full-button page-button" nbButton size="giant" shape="round" outline status="basic"><nb-icon icon="{{page.icon}}"></nb-icon>{{page.name}}</button>
  </nb-card-body>
</nb-card>
